/**
 * Título da etapa, dentro do card, no braço `guided`.
 * O fade in/out fica no CSS da transição de rota — só esta peça anima.
 */
export default function SignupStepHeading({ title, subtitle }) {
  if (!title) return null;
  return (
    <div className="sgf-step-heading">
      <h1 className="sgf-step-title deco-headline">{title}</h1>
      {subtitle ? <p className="sgf-step-sub">{subtitle}</p> : null}
    </div>
  );
}
